import BasePointTagManager from "../../../../../src/managers/BasePointTagManager";
import { Coord } from "../../../../../src/types/Interface";
import { eventBus, EnumEventBus } from "./EventBus";


export default class PointTagManager extends BasePointTagManager {
  constructor(cCoord:Coord) {
    super(cCoord, ["A", "B", "C", "D"]);
    eventBus.on(EnumEventBus.catMode, v => setTimeout(() => this.setAllVisible(!v), v ? 0 : 300));
  }
}